export enum AudienceTypeEnum {
  OPTIN = 0,
  OPTOUT = 1,
}
